export default {
  header: 'Deze week',
  metrics: {
    points: 'Punten',
    visits: 'Bezoeken',
    in_store_sign_ups: 'In-store aanmeldingen',
    rewards_redeemed: 'Beloningen ingewisseld',
  },
};
